var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManBeard3E(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type3_x5F_beards"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x34_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.9,325.7c-15.4-21.3-12.4-48.3-12.2-73.5c-5.4,7.7-6.3,29.3-7.3,38.8c-1.1,10.5-3.7,17.6-11.3,25.7 c-8,8.6-14.3,13.1-16.6,23.9c-0.7,3.1-1.1,12.5-5.7,13.4c-5.9,1.1-9-7-11-10c-4.8-7.5-12.3-16.3-22-15.1c-5.1,0.7-10,4.7-14.8,6.2 c-9.8,3.4-23.4,1.4-31.9-1.2c-4.8-1.5-7.6-3.9-12.7-4.6c-9.7-1.3-20.6,9-25.4,16.5c-2,3.1-5.7,11.7-11.6,10.6 c-4.6-0.8-5.4-12.7-6-15.8c-2.3-10.8-8.6-15.3-16.6-23.9c-7.6-8.2-10.2-15.2-11.3-25.7c-1-9.5-0.5-33.1-6.8-41.6 c0,19,2.4,41.6-4.7,62.6c-0.8,2.4-7.2,13.7-8.5,16c3.2-1.4,10.1-6.9,12.2-10.1c-1,8.7-6.2,15.7-9.5,23.7c3.2,0.4,6.4-1.8,8.9-2.9 c1.7,6.9-1.5,18.5-3.8,24.9c4.1,0.1,10.6-2.3,11.5-5.7c0.1,5.7-0.4,10.6-1.4,16c4.7,0.3,11.6-3.2,12.9-7.1 c3,6.6,4.1,10.6,6.4,18.4c1.4,4.7,0.3,4.9,5.2,2.4c2.4-1.2,5.2-5.8,6.4-8.1c3.2,7.8,21.5,11.3,26,12.8c-6.5-21.5-2.3-48,21.1-51.1 c9.8-1.3,9.4-1.2,20.7-1.1l0,0c0.6,0,1.1,0,1.7,0s1.3,0,2,0l0,0c12-0.1,20.7-0.5,30.5,0.8c23.4,3.1,24.9,36.4,14.9,48.9 c5.2-0.8,19.3-2.5,22.5-10.3c1.1,2.3,3.9,6.8,6.4,8.1c4.8,2.5,3.3,2.1,5.2-2.4c2.6-6.2,4.3-12.4,6.4-18.4 c1.3,3.8,8.2,7.4,12.9,7.1c-1.1-5.4-1.5-10.3-1.4-16c0.9,3.3,7.4,5.8,11.5,5.7c-2.3-6.5-5.6-15.3-3.9-22.2c2.6,1.1,5.4,2.4,8.6,2 c-5.1-7.4-9.2-14.4-10.2-23.1C466.3,323.6,472.7,325.4,476.9,325.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBeard3E);
export default __webpack_public_path__ + "static/media/man_beard_3e.055131aa9816c078fc178a9102c4c795.svg";
export { ForwardRef as ReactComponent };